import SendMsg from './index.vue';
export default SendMsg;
